<template>
    <!--<div style="background-color: #181a1b; color: white; padding: 20px; margin-top: 10px; border-radius: 10px;">-->
    <!--<div><h3>Your Candidates</h3></div>-->
    <table class="dark-table">
        <tbody>
            <th>Last Name</th>
            <th>First Name</th>
            <th>E-Mail</th>
            <th>Phone</th>
            <tr v-for="c in this.candidatesDetails" class="clickable-row" @click="handleCandidateClick(c.id, c.lastname, c.firstname)">
                <td> {{ c.lastname }} </td>
                <td> {{ c.firstname }} </td>
                <td> {{ c.email }} </td>
                <td> {{ formatPhoneNumber(c.phone) }} </td>
            </tr>
            <tr v-if="this.candidatesDetails.length < 1">
                <td colspan="4" class="empty-candidates">No candidates completed assessments.</td>
            </tr>
        </tbody>
    </table>
    <!--<</div>-->
</template>
<script>
export default {
    props: ['candidatesDetails'],
    data() {
        return {

        }
    },
    methods: {
        handleCandidateClick(candidateId, lastname, firstname) {
            if (candidateId !== null) {
                this.$emit('candidate-selected', {"candidateId": candidateId, 
                                                  "lastname": lastname,
                                                  "firstname": firstname});
            }
        },
        formatPhoneNumber(phoneNumber) {
            // Remove all non-numeric characters from the phone number
            const cleaned = ('' + phoneNumber).replace(/\D/g, '');
            
            // Apply formatting
            const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
            return null;
        }
    }
}
</script>
<style scoped>
.clickable-row {
  cursor: pointer;
}
.dark-table {
    background-color: #292929; /* Dark gray background */
    color: #fff; /* White text color */
    border-collapse: collapse; /* Remove default cell spacing */
    width: 100%;
}

.dark-table th,
.dark-table td {
    padding: 10px; /* Add padding to cells */
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #3f3f3f; /* Darker gray for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #333; /* Darker background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #4f4f4f; /* Darker background for hover effect */
}

/* Hint of purple */
.dark-table th,
.dark-table td {
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #27202c; /* Purple background for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #363438; /* Purple background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #2b1542; /* Darker purple background for hover effect */
}

.empty-candidates {

        /* Set background image */
        background-image: url('../../assets/empty-candidates.png');
        
        /* Adjust background properties */
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        height: 300px;
}
</style>